<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <button (click)="reloadPDF()" mat-button>Regenerate</button>
        </div>
        <div class="middle">
            <button (click)="downloadPDF()" mat-button>Download</button>
            <button (click)="printPDF()" mat-button>Print</button>
        </div>
        <div class="right">
            <button mat-button mat-dialog-close>Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">
            <button mat-button>Download</button>
            <button mat-button>Print</button>
        </div>
        <div class="right">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item>
                  <mat-icon>add</mat-icon>
                  <span>New Item</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>content_copy</mat-icon>
                  <span>Duplicate</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>

        </div>
    </div>
</div>

<div class="content">
    <div class="outer">
        <div class="inner">
            <ng-container *ngIf="src == null">
                <div class="generating-pdf">
                    <mat-spinner></mat-spinner>
                    Generating PDF
                </div>
            </ng-container>

            <ng-container *ngIf="src != null">
                <pdf-viewer [src]="src" [render-text]="true" [fit-to-page]="true" [original-size]="false" style="display: block;" class="pdf-viewer"></pdf-viewer>
            </ng-container>
        </div>
    </div>
</div>